var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeloBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "133.30179mm",
    height: "154.49063mm",
    viewBox: "0 0 133.30179 154.49063",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065795023667208011720000011689449865859618471_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#SVGID_1_",
    style: {
      overflow: "visible"
    },
    id: "use9",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 106,
    height: 123.2,
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(78.05571,-33.60208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m -77.787501,165.89374 h 63.774566 v -63.77456 h -63.774566 z m 68.5171061,0 H 54.50416 V 102.11918 H -9.2703949 Z M -77.787501,97.376652 h 63.774566 V 33.60208 h -63.774566 z m 68.5171061,0 H 54.50416 V 33.60208 H -9.2703949 Z",
    id: "path4",
    style: {
      fill: "#00b140",
      strokeWidth: 2.49608
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "matrix(1.2480346,0,0,1.2480346,-77.787501,33.60208)",
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30",
    style: {
      strokeWidth: 2
    }
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#SVGID_1_",
    style: {
      overflow: "visible"
    },
    id: "use1",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000065795023667208011720000011689449865859618471_)",
    id: "g28",
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 91.3,37.4 V 32.6 C 91.3,32.2 91,32 90.7,32 v 0 h -13 c -0.1,0 -0.2,-0.1 -0.2,-0.2 v 0 -2.9 c 0,-0.1 0.1,-0.2 0.2,-0.2 v 0 h 11 c 0.4,0 0.6,-0.3 0.6,-0.6 0,0 0,0 0,0 v -4.2 c 0,-0.4 -0.3,-0.6 -0.6,-0.6 v 0 h -11 c -0.1,0 -0.2,-0.1 -0.2,-0.2 v 0 -2.9 c 0,-0.1 0.1,-0.2 0.2,-0.2 v 0 h 12.9 c 0.4,0 0.6,-0.3 0.6,-0.6 0,0 0,0 0,0 V 14.6 C 91.2,14.2 90.9,14 90.6,14 v 0 H 71.2 c -0.4,0 -0.6,0.3 -0.6,0.6 0,0 0,0 0,0 v 22.7 c 0,0.4 0.3,0.6 0.6,0.6 v 0 h 19.5 c 0.3,0.1 0.6,-0.2 0.6,-0.5 0,0 0,0 0,0",
    id: "path12",
    style: {
      fill: "#ffffff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 28.5,38 c 0.1,0 0.2,-0.1 0.3,-0.2 L 39.2,15 c 0.2,-0.3 0,-0.7 -0.3,-0.9 -0.1,0 -0.2,-0.1 -0.3,-0.1 h -6.4 c -0.4,0 -0.7,0.2 -0.9,0.6 0,0 -3.8,8.4 -4.2,9.3 -0.6,1.4 -1.4,4 -1.4,4 0,0.1 -0.1,0.1 -0.2,0.1 0,0 -0.1,-0.1 -0.1,-0.1 0,0 -0.8,-2.6 -1.4,-4 -0.4,-1 -4.2,-9.3 -4.2,-9.3 C 19.6,14.3 19.3,14 18.9,14 h -6.4 c -0.4,0 -0.6,0.3 -0.6,0.6 0,0.1 0,0.2 0.1,0.3 l 10.4,22.9 c 0.1,0.1 0.2,0.2 0.3,0.2 z",
    id: "path14",
    style: {
      fill: "#ffffff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 34.8,86.8 c 0.4,0 0.6,0.3 0.6,0.6 v 0 4.8 c 0,0.4 -0.3,0.6 -0.6,0.6 0,0 0,0 0,0 H 17.9 c -0.4,0 -0.6,-0.3 -0.6,-0.6 v 0 -22.6 c 0,-0.4 0.3,-0.6 0.6,-0.6 0,0 0,0 0,0 h 5.7 c 0.4,0 0.6,0.3 0.6,0.6 v 0 17.1 c 0,0.1 0.1,0.2 0.2,0.2 v 0 z",
    id: "path16",
    style: {
      fill: "#ffffff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 80.5,68.6 C 73.6,69.1 68.5,75.1 69,82 69.5,88.9 75.5,94 82.4,93.5 88.9,93 94,87.6 94,81 93.6,74 87.6,68.4 80.5,68.6 m 1,18.9 c -3.6,0 -6.4,-2.9 -6.4,-6.5 0,-3.4 2.9,-6.2 6.3,-6.3 3.6,0 6.5,2.8 6.5,6.4 v 0 c -0.1,3.5 -2.9,6.4 -6.4,6.4",
    id: "path18",
    style: {
      fill: "#ffffff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 24.1,122.8 c 0,0 -4.8,-10.3 -4.8,-10.3 -0.1,-0.1 -0.1,-0.2 -0.3,-0.2 h -2.5 c -0.1,0 -0.2,0.1 -0.3,0.2 l -4.8,10.3 c 0,0 0,0.1 0,0.1 0,0.2 0.1,0.3 0.3,0.3 0,0 0,0 0,0 h 2.8 c 0.2,0 0.3,-0.1 0.4,-0.3 0,-0.1 0.3,-0.6 0.6,-1.2 H 20 c 0.3,0.6 0.5,1.1 0.6,1.2 0.1,0.2 0.2,0.3 0.4,0.3 h 2.8 c 0.2,0 0.3,-0.1 0.3,-0.3 v 0 c 0,0 0,0 0,-0.1 m -7.6,-3.3 c 0.1,-0.2 0.2,-0.5 0.3,-0.7 l 0.9,-2.6 c 0,0 0.1,-0.1 0.1,0 0,0 0,0 0,0 l 0.9,2.6 c 0.1,0.2 0.2,0.5 0.3,0.7 z",
    id: "path20",
    style: {
      fill: "#00b140",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 40.2,123.2 h 2.6 c 0.2,0 0.3,-0.1 0.3,-0.3 v 0 -1.6 c 0,0 0,0 0,0 l 1.3,-1.4 c 0,0 0.1,0 0.1,0 0,0 0,0 0,0 l 2.6,3.2 c 0.1,0.1 0.2,0.2 0.3,0.2 h 3.3 c 0.2,0 0.3,-0.1 0.3,-0.3 0,-0.1 0,-0.1 -0.1,-0.2 l -4.3,-5.3 c 0,0 0,-0.1 0,-0.1 l 4.2,-4.5 c 0.1,-0.1 0.1,-0.3 0,-0.4 -0.1,0 -0.1,-0.1 -0.2,-0.1 h -3.2 c -0.1,0 -0.2,0 -0.3,0.1 0,0 -2.4,2.6 -3.1,3.3 -0.7,0.7 -0.9,1 -0.9,1 0,0 -0.1,0 -0.1,0 0,0 0,0 0,-0.1 v -4.1 c 0,-0.2 -0.1,-0.3 -0.3,-0.3 v 0 h -2.6 c -0.2,0 -0.3,0.1 -0.3,0.3 v 0 10.4 c 0.1,0.1 0.3,0.2 0.4,0.2 v 0",
    id: "path22",
    style: {
      fill: "#00b140",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 34.7,123.2 H 37 c 0.2,0 0.3,-0.1 0.3,-0.3 v 0 -10.3 c 0,-0.2 -0.1,-0.3 -0.3,-0.3 v 0 h -2.6 c -0.2,0 -0.3,0.1 -0.3,0.3 v 0 5.5 c 0,0 0,0.1 -0.1,0.1 0,0 0,0 -0.1,0 0,0 -0.6,-0.8 -1,-1.2 l -4.5,-4.5 c -0.1,-0.1 -0.2,-0.1 -0.3,-0.1 h -2.3 c -0.2,0 -0.3,0.1 -0.3,0.3 v 0 10.3 c 0,0.2 0.1,0.3 0.3,0.3 v 0 h 2.6 c 0.2,0 0.3,-0.1 0.3,-0.3 v 0 -5.5 c 0,0 0,-0.1 0.1,-0.1 0,0 0,0 0.1,0 0,0 0.6,0.8 1,1.2 l 4.5,4.5 c 0,0.1 0.1,0.1 0.3,0.1",
    id: "path24",
    style: {
      fill: "#00b140",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 9.2,117.3 c 0.5,-0.5 0.8,-1.2 0.8,-1.9 -0.2,-1.8 -1.8,-3.2 -3.6,-3 H 0.3 c -0.2,0 -0.3,0.1 -0.3,0.3 0,0 0,0 0,0 V 123 c 0,0.2 0.1,0.3 0.3,0.3 0,0 0,0 0,0 h 6.2 c 2,0.1 3.7,-1.4 3.9,-3.4 0,-1 -0.5,-2 -1.2,-2.6 m -6,-2.4 c 0,0 0,0 0,0 L 6,114.8 c 0.4,0 0.8,0.4 0.8,0.8 0,0.4 -0.4,0.8 -0.8,0.8 H 3.3 c 0,0 -0.1,0 -0.1,-0.1 z m 3,5.9 h -3 c 0,0 -0.1,0 -0.1,-0.1 V 119 c 0,0 0,-0.1 0.1,-0.1 h 3 c 0.5,0 1,0.4 1,0.9 0,0.5 -0.4,1 -0.9,1 0,0 0,0 -0.1,0",
    id: "path26",
    style: {
      fill: "#00b140",
      strokeWidth: 2
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#00b140",
      fillOpacity: 1,
      strokeWidth: 0.232581
    },
    id: "rect2",
    width: 133.30179,
    height: 18.23848,
    x: -78.05571,
    y: 169.85423
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontWeight: "bold",
      fontSize: "16.9333px",
      lineHeight: 1.3,
      fontFamily: "'Leelawadee UI'",
      InkscapeFontSpecification: "'Leelawadee UI Bold'",
      textAlign: "justify",
      letterSpacing: "0.576792px",
      wordSpacing: 0,
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    d: "m -51.755929,184.60594 v -11.85662 h 4.316007 q 1.984372,0 3.050971,0.72761 1.066599,0.7276 1.066599,2.05051 0,0.95912 -0.653188,1.67845 -0.644921,0.71934 -1.653643,1.00045 v 0.0331 q 1.265037,0.15709 2.017444,0.93431 0.760676,0.77721 0.760676,1.89342 0,1.62883 -1.165818,2.58795 -1.165818,0.95084 -3.183262,0.95084 z m 2.670633,-9.88878 v 2.81119 h 1.174086 q 0.826822,0 1.29811,-0.39687 0.479556,-0.40515 0.479556,-1.10794 0,-1.30638 -1.951298,-1.30638 z m 0,4.79556 v 3.12539 h 1.446937 q 0.92604,0 1.446938,-0.42995 0.529165,-0.42995 0.529165,-1.17409 0,-0.71106 -0.520897,-1.1162 -0.512629,-0.40515 -1.438669,-0.40515 z m 18.427864,-0.0413 q 0,5.34127 -4.977464,5.34127 -4.828637,0 -4.828637,-5.21725 v -6.84608 h 2.678901 v 6.87916 q 0,2.87734 2.248954,2.87734 2.207613,0 2.207613,-2.77812 v -6.97838 h 2.670633 z m 2.610772,4.67981 v -2.64583 q 0.719334,0.60358 1.562692,0.90951 0.843358,0.29765 1.703252,0.29765 0.504361,0 0.87643,-0.091 0.380338,-0.0909 0.628385,-0.24805 0.256314,-0.16536 0.380337,-0.38033 0.124024,-0.22325 0.124024,-0.47956 0,-0.34726 -0.198437,-0.62012 -0.198438,-0.27285 -0.545703,-0.50436 -0.338996,-0.23151 -0.810284,-0.44648 -0.471289,-0.21497 -1.016991,-0.43822 -1.389059,-0.57877 -2.075321,-1.41386 -0.677993,-0.83509 -0.677993,-2.01744 0,-0.92604 0.372069,-1.5875 0.37207,-0.66973 1.008722,-1.09967 0.644921,-0.42995 1.488278,-0.62839 0.843358,-0.2067 1.785934,-0.2067 0.92604,0 1.637107,0.11575 0.719334,0.10749 1.322914,0.339 v 2.47219 q -0.297656,-0.2067 -0.653189,-0.3638 -0.347265,-0.15709 -0.719335,-0.25631 -0.372069,-0.10749 -0.744139,-0.1571 -0.363801,-0.0496 -0.69453,-0.0496 -0.454751,0 -0.826821,0.0909 -0.37207,0.0827 -0.628384,0.23978 -0.256315,0.1571 -0.396874,0.38034 -0.14056,0.21497 -0.14056,0.48782 0,0.29766 0.157096,0.53744 0.157096,0.23151 0.446483,0.44648 0.289388,0.20671 0.702799,0.41341 0.41341,0.19844 0.934308,0.41341 0.711066,0.29766 1.273304,0.63666 0.570507,0.33072 0.97565,0.7524 0.405142,0.42168 0.620116,0.96738 0.214973,0.53744 0.214973,1.25677 0,0.99219 -0.380338,1.67018 -0.372069,0.66973 -1.01699,1.09141 -0.644921,0.41341 -1.504815,0.59531 -0.851626,0.1819 -1.80247,0.1819 -0.975649,0 -1.860348,-0.16537 -0.876431,-0.16536 -1.521351,-0.49609 z m 13.285034,0.45475 h -2.670633 v -11.85662 h 2.670633 z m 13.93822487,0 H -3.5188385 l -4.8865139,-7.44966 q -0.429947,-0.65319 -0.5953113,-0.98392 h -0.033073 q 0.066146,0.62839 0.066146,1.91823 v 6.51535 h -2.5218053 v -11.85662 h 2.8773384 l 4.7046132,7.21815 q 0.3224603,0.48783 0.5953113,0.96739 h 0.033073 q -0.066146,-0.41342 -0.066146,-1.62884 v -6.5567 h 2.52180497 z m 10.39942993,0 H 2.4653657 v -11.85662 h 6.8378121 v 2.17454 H 5.1359985 v 2.63756 h 3.8777918 v 2.16628 H 5.1359985 v 2.71197 h 4.4400303 z m 1.9327802,-0.45475 v -2.64583 q 0.719335,0.60358 1.562693,0.90951 0.843357,0.29765 1.703251,0.29765 0.504361,0 0.876431,-0.091 0.380338,-0.0909 0.628384,-0.24805 0.256315,-0.16536 0.380338,-0.38033 0.124023,-0.22325 0.124023,-0.47956 0,-0.34726 -0.198437,-0.62012 -0.198437,-0.27285 -0.545702,-0.50436 -0.338997,-0.23151 -0.810285,-0.44648 -0.471288,-0.21497 -1.01699,-0.43822 -1.38906,-0.57877 -2.075321,-1.41386 -0.677994,-0.83509 -0.677994,-2.01744 0,-0.92604 0.37207,-1.5875 0.372069,-0.66973 1.008722,-1.09967 0.64492,-0.42995 1.488278,-0.62839 0.843358,-0.2067 1.785934,-0.2067 0.92604,0 1.637106,0.11575 0.719335,0.10749 1.322914,0.339 v 2.47219 q -0.297656,-0.2067 -0.653189,-0.3638 -0.347265,-0.15709 -0.719334,-0.25631 -0.37207,-0.10749 -0.744139,-0.1571 -0.363802,-0.0496 -0.69453,-0.0496 -0.454752,0 -0.826822,0.0909 -0.372069,0.0827 -0.628384,0.23978 -0.256314,0.1571 -0.396874,0.38034 -0.14056,0.21497 -0.14056,0.48782 0,0.29766 0.157096,0.53744 0.157097,0.23151 0.446484,0.44648 0.289387,0.20671 0.702798,0.41341 0.413411,0.19844 0.934308,0.41341 0.711066,0.29766 1.273305,0.63666 0.570507,0.33072 0.975649,0.7524 0.405142,0.42168 0.620116,0.96738 0.214974,0.53744 0.214974,1.25677 0,0.99219 -0.380338,1.67018 -0.37207,0.66973 -1.01699,1.09141 -0.644921,0.41341 -1.504815,0.59531 -0.851626,0.1819 -1.802471,0.1819 -0.975649,0 -1.860347,-0.16537 -0.876431,-0.16536 -1.521352,-0.49609 z m 10.068695,0 v -2.64583 q 0.719335,0.60358 1.562693,0.90951 0.843357,0.29765 1.703252,0.29765 0.50436,0 0.87643,-0.091 0.380338,-0.0909 0.628384,-0.24805 0.256315,-0.16536 0.380338,-0.38033 0.124023,-0.22325 0.124023,-0.47956 0,-0.34726 -0.198437,-0.62012 -0.198437,-0.27285 -0.545702,-0.50436 -0.338997,-0.23151 -0.810285,-0.44648 -0.471288,-0.21497 -1.01699,-0.43822 -1.38906,-0.57877 -2.075321,-1.41386 -0.677994,-0.83509 -0.677994,-2.01744 0,-0.92604 0.37207,-1.5875 0.372069,-0.66973 1.008722,-1.09967 0.64492,-0.42995 1.488278,-0.62839 0.843358,-0.2067 1.785934,-0.2067 0.92604,0 1.637106,0.11575 0.719335,0.10749 1.322914,0.339 v 2.47219 q -0.297655,-0.2067 -0.653189,-0.3638 -0.347265,-0.15709 -0.719334,-0.25631 -0.37207,-0.10749 -0.744139,-0.1571 -0.363802,-0.0496 -0.69453,-0.0496 -0.454752,0 -0.826821,0.0909 -0.37207,0.0827 -0.628385,0.23978 -0.256314,0.1571 -0.396874,0.38034 -0.140559,0.21497 -0.140559,0.48782 0,0.29766 0.157096,0.53744 0.157096,0.23151 0.446483,0.44648 0.289388,0.20671 0.702798,0.41341 0.413411,0.19844 0.934308,0.41341 0.711067,0.29766 1.273305,0.63666 0.570507,0.33072 0.975649,0.7524 0.405143,0.42168 0.620116,0.96738 0.214974,0.53744 0.214974,1.25677 0,0.99219 -0.380338,1.67018 -0.37207,0.66973 -1.01699,1.09141 -0.644921,0.41341 -1.504815,0.59531 -0.851626,0.1819 -1.802471,0.1819 -0.975649,0 -1.860347,-0.16537 -0.876431,-0.16536 -1.521352,-0.49609 z",
    id: "text2",
    "aria-label": "BUSINESS"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloBusiness);
export default __webpack_public_path__ + "static/media/velo-business.7c398f1a3799157eb913a4ae264142aa.svg";
export { ForwardRef as ReactComponent };